import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    Input,
    Row,
    Col,
    Label,
    FormGroup,
    FormFeedback,
} from "reactstrap";
import Select from "react-select";

const defaultWorkShiftForm = {
    id: "",
    title: "",
    loginTime: "",
};

const WorkShiftAddEditModal = ({
    workShiftAddEditModalOpen,
    setWorkShiftAddEditModalOpen,
    editableData = null, // pass existing item to edit
    onSubmit, // function(finalData) => void
}) => {
    const [workShiftForm, setWorkShiftForm] = useState({ ...defaultWorkShiftForm });
    const [errors, setErrors] = useState({});
    const formatMinuteToTime = (minuteValue) => {
        const totalMinutes = Number(minuteValue);
        if (Number.isNaN(totalMinutes) || totalMinutes < 0) return "";
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    };
    const timeOptions = Array.from({ length: 24 * 4 }).map((_, index) => {
        const hours = Math.floor(index / 4);
        const minutes = (index % 4) * 15;
        const label = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        return { value: label, label };
    });

    useEffect(() => {
        if (!workShiftAddEditModalOpen) return;
        if (editableData?.id || editableData?._id) {
            setWorkShiftForm({
                id: editableData?.id || editableData?._id || "",
                title: editableData?.workShiftTitle || editableData?.title || editableData?.name || "",
                loginTime:
                    editableData?.workShiftTimeDisplay ||
                    editableData?.loginTime ||
                    editableData?.logInTime ||
                    editableData?.time ||
                    formatMinuteToTime(editableData?.workShiftInMinute),
            });
        } else {
            setWorkShiftForm({ ...defaultWorkShiftForm });
        }
        setErrors({});
    }, [editableData, workShiftAddEditModalOpen]);

    const closeModal = () => {
        setWorkShiftAddEditModalOpen(false);
    };

    const handleWorkShiftFormChange = (field, value) => {
        setWorkShiftForm((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => {
            if (!prev[field]) return prev;
            const copy = { ...prev };
            delete copy[field];
            return copy;
        });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!String(workShiftForm?.title || "").trim()) {
            newErrors.title = "Title is required.";
        }

        if (!String(workShiftForm?.loginTime || "").trim()) {
            newErrors.loginTime = "Login Time is required.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validateForm()) return;
        const finalData = { ...workShiftForm };

        if (typeof onSubmit === "function") {
            onSubmit(finalData);
        }
    };

    return (
        <Modal
            isOpen={workShiftAddEditModalOpen}
            toggle={closeModal}
            backdrop="static"
            size="md"
            className="modal-full-height"
            centered
        >
            <ModalBody className="modal-height-fixed overflow-y-auto">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold m-0">
                        {workShiftForm?.id ? "UPDATE" : "CREATE"}
                    </h5>
                    <Button close onClick={closeModal} />
                </div>
                <hr />

                <Row className="mt-3">
                    <Col md={12}>
                        <FormGroup>
                            <Label className="fw-semibold">Title *</Label>
                            <Input
                                type="text"
                                value={workShiftForm?.title || ""}
                                invalid={!!errors.title}
                                onChange={(e) => handleWorkShiftFormChange("title", e.target.value)}
                            />
                            <FormFeedback>{errors.title}</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col md={12}>
                        <FormGroup>
                            <Label className="fw-semibold">Log In Time *</Label>
                            <Select
                                options={timeOptions}
                                className="select2-selection"
                                placeholder="Select Time"
                                value={
                                    timeOptions.find(
                                        (option) => String(option?.value) === String(workShiftForm?.loginTime || "")
                                    ) || null
                                }
                                onChange={(selectedOption) =>
                                    handleWorkShiftFormChange("loginTime", selectedOption?.value || "")
                                }
                                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                            {errors.loginTime && (
                                <FormFeedback className="d-block">{errors.loginTime}</FormFeedback>
                            )}
                        </FormGroup>
                    </Col>
                </Row>

                <div className="text-end mt-4">
                    <Button color="primary" onClick={handleSubmit}>
                        Save
                    </Button>
                </div>
            </ModalBody>

        </Modal>
    );
};

export default WorkShiftAddEditModal;
